module.exports = __webpack_public_path__ + "static/media/007.ced94005.jpg";